import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  priceBooks: [],
  loading: false,
  error: null,
};

const getPriceBookSlice = createSlice({
  name: "getPriceBook",
  initialState,
  reducers: {
    fetchPriceBookRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchPriceBookSuccess: (state, action) => {
      state.loading = false;
      state.priceBooks = action.payload;
    },

    fetchPriceBookFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchPriceBookRequest,
  fetchPriceBookSuccess,
  fetchPriceBookFailure,
} = getPriceBookSlice.actions;

export default getPriceBookSlice.reducer;